import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import { LineOfBusinessEnum } from '../../../constants/BusinessConstants';
import React from 'react';
import style from './NotificationTitle.module.scss';
import { common } from '../../../common/constants';

const NotificationTitle = ({ title, data, readNotification }) => {
    const { redirect_id } = data;
    const parsedRedirectId = redirect_id && JSON.parse(redirect_id);
    const patientToMember = LineOfBusinessEnum?.patientToMember;
    const patientToMemberLowerCase = LineOfBusinessEnum?.patientToMember.toLowerCase();
    const patientsToMembers = LineOfBusinessEnum?.patientsToMembers;
    const patientsToMembersLowerCase = patientsToMembers.toLowerCase();

    let finalTitle = title
        .replaceAll('#VerbiasLowerCase', patientToMemberLowerCase)
        .replaceAll('#Verbias', patientToMember);

    const dynamicLink = {
        '#PatientName': {
            value: parsedRedirectId['#PatientName'],
            link: `/${patientsToMembersLowerCase}/${patientToMemberLowerCase}-details/${parsedRedirectId['#PatientId']}`,
        },
        '#PatientId': {
            value: parsedRedirectId['#PatientId'],
            link: `/${patientsToMembersLowerCase}/${patientToMemberLowerCase}-details/${parsedRedirectId['#PatientId']}`,
        },
        '#OrderId': {
            value: parsedRedirectId['#OrderId'],
            link: `/orders/order-details/${parsedRedirectId['#OrderId']}`,
        },
        '#SupplyOrderId': {
            value: parsedRedirectId['#SupplyOrderId'],
            link: `/orders/supply-order-details/${parsedRedirectId['#SupplyOrderId']}`,
        },
        '#OrderApprovalId': {
            value: parsedRedirectId['#OrderApprovalId'],
            link: `/order-approvals/order-approval-details/${parsedRedirectId['#OrderApprovalId']}`,
        },
        '#RecurringOrderId': {
            value: parsedRedirectId['#RecurringOrderId'],
            link: `/recurring-orders/recurring-order-details/${parsedRedirectId['#RecurringOrderId']}`,
        },
        '#ParentOrderId': {
            value: parsedRedirectId['#ParentOrderId'],
            link: `/orders/order-details/${parsedRedirectId['#ParentOrderId']}`,
        },
    };

    const renderWithLinks = (text) => {
        const parts = text.split(/(\s+)/);
        return parts.map((part, index) => {
            const cleanedPart = part.replace(/[\s().,]/g, '');
            const punctuation = part.match(/[.,]$/)?.[0] ?? '';
            if (dynamicLink[cleanedPart]?.value) {
                const hasBrackets = part.includes('(') && part.includes(')');
                return (
                    <>
                        {hasBrackets && <span></span>}
                        <Link
                            key={`${part}-${index}`}
                            component={RouterLink}
                            to={dynamicLink[cleanedPart].link}
                            color="primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                readNotification(e, data, dynamicLink[cleanedPart].link);
                            }}
                        >
                            {dynamicLink[cleanedPart].value}
                        </Link>
                        {hasBrackets && <span></span>}
                        {punctuation && <span>{punctuation}</span>}
                    </>
                );
            }
            if (part.includes(common.paceEmail)) {
                return (
                    <>
                        <Link
                            key={`email-${index}`}
                            href={`mailto:${common.paceEmail}`}
                            color="primary"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {common.paceEmail}
                        </Link>
                        {punctuation && <span>{punctuation}</span>}
                    </>
                );
            }
            return <span key={index} className={style.displayLineBreak}>{part}</span>;
        });
    };
    return <>{renderWithLinks(finalTitle)}</>;
};
export default NotificationTitle;